import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Select from "react-select";
// i18n
import { withTranslation } from "react-i18next";
import Snackbars from "../../Utils/Snackbars";
import useRequests from "../../Utils/useRequests";
import { useHistory } from "react-router-dom";

const colourStyles = {
  menuList: (styles) => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? "#036B41"
      : isSelected
      ? isSelected
        ? "#036B41"
        : "#000"
      : undefined,
    zIndex: 1,
    color: isFocused
      ? "#fff"
      : isSelected
      ? isSelected
        ? "#F7F7FA"
        : "#000"
      : undefined,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 100,
  }),
};

const StkyManagement = (props) => {
  const [modal_Delete_Stky, setmodal_Delete_Stky] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewData, setViewData] = useState({});
  const [deleteStkyId, setDeleteStkyId] = useState(null);

  const { getRequest, postRequest } = useRequests();
  const location = useLocation();
  const history = useHistory();
  React.useEffect(() => {
    if (localStorage.getItem('admin_type') !== 'admin') {
      history.replace('/dashboard');
    }
  }, [history]);

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, 5000);
  };

  // Delete Modal
  function Delete_Stky(stky_id) {
    setDeleteStkyId(stky_id);
    setmodal_Delete_Stky(!modal_Delete_Stky);
  }

  const handleDeleteStky = async () => {
    try {
      const jsonpar = JSON.stringify({ stky_id: deleteStkyId });
      const res = await postRequest("delete-stky", jsonpar);
      if (res && res.code === 200) {
        setAlertData({ variant: "success", message: res.message });
        setDeleteStkyId(null);
        handleLoadGetStky();
      } else {
        setAlertData({
          variant: "error",
          message: res.message || "Failed to delete ttk",
        });
      }
    } catch (error) {
      console.error("Delete Error:", error);
      setAlertData({
        variant: "error",
        message: "Something went wrong while deleting ttk",
      });
    }
    resetAlertData();
    setmodal_Delete_Stky(false);
  };

  const [statusModal, setStatusModal] = useState(false);
  const [selectedCrewId, setSelectedCrewId] = useState(null);
  const [status, setStatus] = useState("");

  const openStatusModal = (crewm_id, status) => {
    setSelectedCrewId(crewm_id);
    setStatus(status === "active" ? "inactive" : "active");
    setStatusModal(true);
  };

  const handleChangeStatus = async () => {
    try {
      const jsonpar = JSON.stringify({
        stky_id: selectedCrewId,
        status: status,
      });
      const res = await postRequest("update-stky-status", jsonpar);
      if (res && res.code === 200) {
        setAlertData({
          variant: "success",
          message: res.message || "Status updated successfully",
        });
        handleLoadGetStky();
      } else {
        setAlertData({
          variant: "error",
          message: res.message || "Failed to update status",
        });
      }
    } catch (error) {
      console.error("Status Update Error:", error);
      setAlertData({
        variant: "error",
        message: "Something went wrong while updating status",
      });
    }
    resetAlertData();
    setStatusModal(false);
  };

  const [StkyData, setStkyData] = React.useState([]);
  const [StkyTBody, setStkyTBody] = React.useState("");

  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>
          {localStorage.getItem("I18N_LANGUAGE") === "eng"
            ? element.energy_type
            : element.energy_type_sp}
        </td>
        <td>{element.identified_hazard}</td>
        <td>
          <Button
            className="status-btn"
            color={element.status === "active" ? "success" : "danger"}
            onClick={() => openStatusModal(element.stky_id, element.status)}
          >
            {element.status.toUpperCase()}
          </Button>
        </td>
        <td className="text-center">
          <div className="centerLink">
            <Link
              title="View TTK"
              to="#"
              className="ont-size-14 bg-primary edit-box"
              onClick={() => {
                setViewData(element);
                setViewModal(true);
              }}
            >
              <i className="bx bx-show"></i>
            </Link>

            <Link
              title="Edit TTK"
              to={"/edit_stky/" + btoa(element.stky_id)}
              className="font-size-14 bg-primary edit-box ms-2"
            >
              <i className="bx bxs-edit"></i>
            </Link>
            
            <Link
              title="Delete TTK"
              to="#"
              className="font-size-14 bg-primary edit-box ms-2"
              onClick={() => {
                Delete_Stky(element.stky_id);
              }}
            >
              <i className="bx bx-trash"></i>
            </Link>


          </div>
        </td>
      </tr>
    ));
    setStkyTBody(tempTBody);
  };

  const handleLoadGetStky = async () => {
    const res = await getRequest("get-stky");
    if (res && res.code === 200) {
      let originalText = res.data;
      const filtered = originalText.filter(
        (item) => item.lang === localStorage.getItem("I18N_LANGUAGE")
      );
      setStkyData(filtered);
      handleT1Body(filtered);
    } else {
      let tempTBody = (
        <tr>
          <td colSpan="9" className="text-center">
            No records found
          </td>
        </tr>
      );
      setStkyTBody(tempTBody);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }));
    }
    resetAlertData();
  };

  React.useEffect(() => {
    handleLoadGetStky();
    if (
      typeof location.state !== "undefined" &&
      typeof location.state.message !== "undefined"
    ) {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
    }
  }, []);

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Utilize Safety")}
            breadcrumbItem={props.t("Things that kill")}
          />
          <Row className="mb-3">
            <Col className="text-end">
              <Link to="/add_stky" className="btn btn-primary">
                + Add
              </Link>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <table
                        className="table table-hover table-highlight"
                        style={{ minWidth: "800px" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "200px" }}>Energy Type</th>
                            <th style={{ width: "200px" }}>Identified Hazard</th>
                            <th>Status</th>
                            <th
                              className="text-center"
                              style={{ width: "200px" }}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>{StkyTBody}</tbody>
                      </table>
                    </div>
                    <div className="infoIcon">
                      <div className="infoIconBox">
                        <i className="bx bx-show"></i>
                        <p>View TTK</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bxs-edit"></i>
                        <p>Edit TTK</p>
                      </div>

                      <div className="infoIconBox">
                        <i className="bx bx-trash"></i>
                        <p>Delete TTK</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Delete Modal */}
      <Modal
        isOpen={modal_Delete_Stky}
        toggle={() => {
          Delete_Stky();
        }}
        backdrop={"static"}
        centered
        className="transation"
      >
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Delete Stky</h5>
            <button
              type="button"
              onClick={() => {
                setmodal_Delete_Stky(false);
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <p>Are you sure you want to delete this stky?</p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={handleDeleteStky}>
              Delete
            </Button>
            <Button
              type="button"
              color="light"
              onClick={() => {
                setmodal_Delete_Stky(false);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>

      {/* View Modal */}
      <Modal isOpen={viewModal} toggle={() => setViewModal(false)} centered size="lg">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Things That Kill Details</h5>
          <button
            type="button"
            onClick={() => setViewModal(false)}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
           <p>
            <strong>Energy Type :</strong>{" "}
            {viewData.energy_type || "N/A"}
          </p>
           <p>
            <strong>Identified Hazard :</strong>{" "}
            {viewData.identified_hazard || "N/A"}
          </p>
          <p>
            <strong>Preventive Controls (Prevents energy from being released) :</strong>{" "}
            {viewData.preventive_controls || "N/A"}
          </p>
          <p>
            <strong>Mitigative Controls (Controls the enrgy when its released) :</strong>{" "}
            {viewData.mitigative_controls || "N/A"}
          </p>
          <p>
            <strong>Control Lead (Crew individuals) :</strong> {viewData.control_lead || "N/A"}
          </p>
        </ModalBody>
        <ModalFooter>
         
        </ModalFooter>
      </Modal>

      {/* Status Modal */}
      <Modal
        isOpen={statusModal}
        toggle={() => setStatusModal(!statusModal)}
        centered
      >
        <ModalBody>
          <h5>Change Status</h5>
          <p>Are you sure you want to update the status?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setStatusModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleChangeStatus}>
            Change Status
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(StkyManagement);
